import * as React from "react";
import "./LoginPanel.css";
import { Form, Header, Divider, Button, Message } from "semantic-ui-react";
import { withRouter, RouteComponentProps, Redirect, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { login, googleLogin } from "../../actions/user.actions";
import  store  from "../../config/store";
import { getAuth, GoogleAuthProvider, signInWithPopup, signInWithRedirect, getRedirectResult } from 'firebase/auth';

interface LoginPanelState {
    email: string;
    password: string;
}

interface LoginPanelProps extends RouteComponentProps<void> {
    dispatch: Dispatch<any>;
    authentication: any;
}

const mapStateToProps = (state: any) => {
    return { authentication: state.authentication };
};

class LoginPanel extends React.Component<LoginPanelProps, LoginPanelState> {
    constructor(props: LoginPanelProps) {
        super(props);

        this.state = {
            email: "",
            password: "",
        };

    }

    componentDidMount() {
        // Handle redirect result if user was redirected back from Google
        const auth = getAuth();
        getRedirectResult(auth).then(async (result) => {
            if (result) {
                // Get the ID token from the user
                const idToken = await result.user.getIdToken();
                this.props.dispatch(googleLogin(idToken));
            }
        }).catch((error) => {
            console.log('Redirect result error:', error);
        });
    }

    handleChange = (event: React.SyntheticEvent<HTMLElement>) => {
        const target: HTMLInputElement = event.target as HTMLInputElement;
        this.setState({...this.state, [target.name]: target.value});
    }

    submitLogin = () => {
        this.props.dispatch(login(this.state));
    }
    
    googleSignIn= ()=>{
        const react_context = this;
        const auth = getAuth();
        const provider = new GoogleAuthProvider();
        
        // Try popup first, fallback to redirect if popup is blocked
        signInWithPopup(auth, provider).then(async (result) => {
            // Get the ID token from the user
            const idToken = await result.user.getIdToken();
            react_context.props.dispatch(googleLogin(idToken));
        }).catch(function (error) {
            console.log('Popup failed, trying redirect:', error.code);
            if (error.code === 'auth/popup-blocked' || error.code === 'auth/popup-closed-by-user') {
                // Fallback to redirect
                signInWithRedirect(auth, provider);
            } else {
                console.log('errorCode: ' + error.code);
                console.log('erroMsg: ' + error.message);
            }
        });
        
    }
    
    render() {
        // Check if user is already logged in
        if (this.props.authentication && this.props.authentication.login) {
            return <Redirect to="/"/>;
        }

        return (
            <>
                    <div className="login-panel ">

                        <Header as="h1" inverted={true}>Login</Header>
                        
                        {/* Show backend offline warning 
                        <Message warning size="tiny" style={{ marginBottom: '20px' }}>
                            <Message.Header>Backend Services Offline</Message.Header>
                            <p>Some features may be limited. You can still use social login options.</p>
                        </Message>*/}
                        
                        <Form>
                            <Form.Field>
                                <a className="fluid ui button orange" onClick={this.googleSignIn}>Google</a>
                            </Form.Field>
                            <Form.Field>
                                <div className="g-signin2 fluid ui" data-onsuccess="requestGoogleLogin"></div>
                            </Form.Field>
                            <Divider horizontal={true} inverted={true}>Or</Divider>
                            
                            {/* Show login error message if any */}
                            {store.getState().authentication.errors ?
                                <p id='loginErrorMessage'>
                                    These credentials don't exist.
                                </p>
                                : ''}
                            
                            <Form.Field>
                                <input
                                    name="email"
                                    type="text"
                                    placeholder="Email"
                                    value={this.state.email}
                                    onChange={this.handleChange}
                                />
                            </Form.Field>
                            <Form.Field>
                                <input
                                    name="password"
                                    type="password"
                                    placeholder="Password"
                                    value={this.state.password}
                                    onChange={this.handleChange}
                                />
                            </Form.Field>
                            <Button fluid={true} onClick={this.submitLogin}>Log in</Button>
                            <Divider inverted={true} />
                            <p>Need an account? <Link to="/signup/confirm/email">Sign Up</Link></p>
                            <Link to="/account/recovery">Forgot your password?</Link>
                        </Form>
                    </div>

            </>
        );
                
    }
}

export default connect(mapStateToProps)(withRouter(LoginPanel));
